{
  "nl": {
    "issue_status": {
      "actions": {
        "create": "Puntenstatus maken"
      },
      "labels": {
        "backup_status": "Vervangende status",
        "customer_status": "Klant zal zien",
        "delete_status": "Status \"{name}\" verwijderen?",
        "delete_status_disclaimer": "Alle nazorgpunten met deze status worden toegewezen aan de status die u hieronder selecteert.",
        "inbox_hint": "Standaard status voor klant inbox",
        "internal_status": "Interne status",
        "new_issue_status": "Status"
      }
    }
  }
}